export default [
  {
    name: 'auditUser',
    path: '/receptionSupervise/userManagement/auditUser',
    meta: { title: '订单管理' },
    component: require('business/receptionSupervise/userManagement/auditUser/list.vue').default
  },
  {
    name: 'reservationUser',
    path: '/receptionSupervise/userManagement/reservationUser',
    meta: { title: '订单管理' },
    component: require('business/receptionSupervise/userManagement/reservationUser/list.vue').default
  }
];
